import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'classesStudents.notifyStudentModal.title',
    defaultMessage: 'NOTIFY STUDENTS',
  },
  subtitle: {
    id: 'classesStudents.notifyStudentModal.subtitle',
    defaultMessage:
      'Below you can select the students you want to notify by sending an email with credentials to access the Student Area',
  },
  cancel: {
    id: 'classesStudents.notifyStudentModal.cancel',
    defaultMessage: 'Cancel',
  },
  sendEmail: {
    id: 'classesStudents.notifyStudentModal.sendEmail',
    defaultMessage: 'Send Email',
  },
  studentName: {
    id: 'classesStudents.notifyStudentModal.studentName',
    defaultMessage: 'Student Name',
  },
  email: {
    id: 'classesStudents.notifyStudentModal.email',
    defaultMessage: 'Email',
  },
  notifiedIn: {
    id: 'classesStudents.notifyStudentModal.notifiedIn',
    defaultMessage: 'Notified In',
  },
  genericError: {
    id: 'classesStudents.notifyStudentModal.genericError',
    defaultMessage: 'An error ocurred, please try again later.',
  },
});
